import {
  getAccountIntegrationsAction,
  getAccountIntegrationsFailAction,
  getAccountIntegrationsSuccessAction,
} from '../integrations.actions';
import { AccountIntegrations } from '../interfaces';
import { createReducer, Action, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export interface State extends EntityState<AccountIntegrations> {
  isLoading: boolean;
}

export function selectId(a: AccountIntegrations): string {
  return a.id;
}

export function sortByName(
  a: AccountIntegrations,
  b: AccountIntegrations,
): number {
  return a.id.localeCompare(b.id);
}

export const adapter: EntityAdapter<AccountIntegrations> = createEntityAdapter<
  AccountIntegrations
>({
  selectId,
  sortComparer: sortByName,
});

export const initialState: State = adapter.getInitialState({
  isLoading: false,
});

const accountIntegrationsReducer = createReducer(
  initialState,
  on(getAccountIntegrationsAction, (state) => ({ ...state, isLoading: true })),
  on(getAccountIntegrationsSuccessAction, (state, action) => ({
    ...state,
    ...adapter.setAll(action.accountIntegrations, state),
    isLoading: false,
  })),
  on(getAccountIntegrationsFailAction, (state) => ({
    ...state,
    isLoading: false,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return accountIntegrationsReducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
